'use client';
import React, { useLayoutEffect, useRef } from 'react';

import cx from 'classnames';

import Backdrop from '../Backdrop/Backdrop';
import { getCordinates } from './helper';

import styles from './absoluteWrapper.module.scss';

export type Placement = 'top' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

interface Props {
  children: React.ReactNode;
  placement?: Placement;
  componentToTrigger?: React.ReactNode;
  width?: string;
}

const AbsoluteWrapper = (props: Props) => {
  const { children, componentToTrigger, placement = 'bottom', width } = props;

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [cordinates, setCordinates] = React.useState({
    top: 0,
    left: 0,
  });

  const contentRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);

  useLayoutEffect(() => {
    if (!contentRef.current || !triggerRef.current) return;
    const {
      height: contentHeight,
      width: contentWidth,
      x,
      y,
    } = contentRef.current.getBoundingClientRect();
    const { height, width } = triggerRef.current.getBoundingClientRect();
    const { left, top } = getCordinates(
      height,
      width,
      contentHeight,
      contentWidth,
      placement,
      x,
      y,
    );

    setCordinates({
      top,
      left,
    });
  }, [isMenuOpen, placement]);

  return (
    <div className={styles.container}>
      <Backdrop visible={isMenuOpen} setVisible={setIsMenuOpen} isTransparent />
      <button
        className={styles.button}
        ref={triggerRef}
        // onBlur={() => setIsMenuOpen(false)}
        onClick={() => setIsMenuOpen(true)}
      >
        {componentToTrigger}
        <div
          className={cx(styles.children)}
          ref={contentRef}
          style={{
            top: cordinates.top,
            left: cordinates.left,
            display: isMenuOpen ? 'block' : 'none',
            width: width,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* clone react element to make new childer */}
          {React.cloneElement(children as React.ReactElement, {
            visible: isMenuOpen,
            setVisible: setIsMenuOpen,
          })}
        </div>
      </button>
    </div>
  );
};

export default AbsoluteWrapper;
